<template>
  <div class="board-content" v-if="board">
    <input class="title-input" v-model="board.title" type="text" placeholder="Название доски" />
    <div class="users-container">
      <v-autocomplete
        v-model="selectedUser"
        @update-items="loadSuggestionUsers"
        :items="suggestedUsers"
        :get-label="getLabel"
        :component-item="template"
        @item-clicked="addUser"
        @keyup.enter.native="addSelectedUser"
        placeholder="Введите имя чтобы добавить пользователя"
      />
      <div class="users">
        <div class="user mt-1 mr-1" v-for="user in board.users" :key="user.id">
          <font-awesome-icon class="delete" icon="times" @click="deleteUser(user)" />
          <span class="ml-1">{{ user.name }}</span>
        </div>
      </div>
    </div>
    <div class="fields-container">
      <div class="fields">
        <div class="title">
          <span>Числовые поля</span>
          <Button class="ml-1" @click="newField()" icon="plus" />
        </div>
        <div v-for="field in fields" :key="field.id">
          <grid columns="6">
            <c span="2" span-s="3">
              <input class="w-100 h-100" type="text" v-model="field.description" placeholder="Название" />
            </c>
            <c span="2" span-s="3">
              <input class="w-100 h-100" type="text" v-model="field.suffix" placeholder="Суффикс" />
            </c>
            <c span-s="2">
              <input class="align-middle" type="checkbox" v-model="field.show_total" />
              <span class="align-middle">список</span>
            </c>
            <c span-s="2">
              <input class="align-middle" type="checkbox" v-model="field.show_on_card" />
              <span class="align-middle">карточка</span>
            </c>
          </grid>
        </div>
      </div>

      <div class="fields mt-2">
        <div class="title">
          <span>Текстовые поля</span>
          <Button class="ml-1" @click="newFieldTxt()" icon="plus" />
        </div>
        <div v-for="field in fieldsTxt" :key="field.id">
          <grid columns="6">
            <c span="2" span-s="3">
              <input class="w-100 h-100" type="text" v-model="field.description" placeholder="Название" />
            </c>
            <c span="2" span-s="3">
              <input class="w-100 h-100" type="text" v-model="field.suffix" placeholder="Суффикс" />
            </c>
            <c span-s="2">
              <select class="h-100 w-100 align-middle" v-model="field.type">
                <option value="0">Текст</option>
                <option value="1">Ссылка</option>
              </select>
            </c>
            <c span-s="2">
              <input class="align-middle" type="checkbox" v-model="field.show_on_card" />
              <span class="align-middle">карточка</span>
            </c>
          </grid>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UserTemplate from "@/templates/UserTemplate.vue";

export default {
  name: "EditBoardContent",
  props: ["board"],
  computed: {
    fields() {
      if (!this.board) return [];
      return this.copyAndSort(this.board.fields);
    },
    fieldsTxt() {
      if (!this.board) return [];
      return this.copyAndSort(this.board.fieldsTxt);
    }
  },
  data() {
    return {
      selectedUser: null,
      suggestedUsers: [],
      template: UserTemplate
    };
  },
  sockets: {
    suggested_users(data) {
      if (data.users) {
        this.suggestedUsers = data.users;
      }
    }
  },
  methods: {
    copyAndSort(fields) {
      if (!fields) return [];
      fields = fields.slice(0);

      fields.sort((f1, f2) => {
        if (!f1.id) {
          return -10000;
        }
        if (!f2.id) {
          return 10000;
        }
        return f1.description.localeCompare(f2.description);
      });

      return fields;
    },
    newField() {
      if (!this.board) {
        return;
      }

      this.board.fields.push({
        new: true,
        description: "",
        suffix: "",
        show_on_card: false,
        show_total: false
      });
    },
    newFieldTxt() {
      if (!this.board) {
        return;
      }

      this.board.fieldsTxt.push({
        new: true,
        description: "",
        suffix: "",
        show_on_card: false,
        type: 0
      });
    },
    loadSuggestionUsers(text) {
      if (!text) {
        return;
      }

      this.suggestedUsers = [];
      this.$socket.emit("get_suggested_users", text);
    },
    getLabel(user) {
      if (!user) return "";
      if (user.riot_name) return user.name + " " + user.riot_name;
      return user.name;
    },
    addSelectedUser() {
      this.addUser(this.selectedUser);
    },
    addUser(user) {
      if (!user) {
        return;
      }

      this.selectedUser = null;
      this.suggestedUsers = [];
      this.$store.dispatch("boards/addUser", {
        board: this.board,
        user: user
      });
    },
    deleteUser(user) {
      this.$modal.show("ConfirmationDialog", {
        message: `Точно <b>удалить</b> пользователя <b>${user.name}</b> из этой доске?`,
        yes: () => {
          this.$store.dispatch("boards/deleteUser", {
            board: this.board,
            user: user
          });
        }
      });
    }
  }
};
</script>

<style lang="postcss" scoped>
.board-content {
  display: grid;
  grid-gap: var(--gap-sm);
  grid-template-columns: 1fr;
  grid-template-rows: auto auto 1fr auto;
  grid-template-areas:
    "title"
    "users"
    "board-fields"
    "buttons";
  height: 100%;
}

.title-input {
  grid-area: title;
}

.users-container {
  grid-area: users;

  .users {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .title {
      display: grid;
    }
  }
}

.fields-container {
  grid-area: board-fields;
  margin: var(--gap-md) 0;

  .fields {
    .title {
      display: grid;
      grid-auto-flow: column;
      grid-template-columns: auto auto 1fr;
      grid-tempate-rows: 2em;
      align-items: center;

      span {
      }
    }
  }

  .header {
    align-content: center;
    font-weight: bold;

    & > span {
      text-align: center;
    }
  }

  input {
    height: 2em;
  }
}
</style>


